import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

export default function ViewSolid({ theme, ...props }) {
  return (
    <svg
      aria-labelledby={props.ariaTags.labelledBy}
      aria-hidden={props.ariaTags.hidden}
      className={cx(theme.container, theme[props.svg], props.className)}
      shapeRendering="geometricPrecision"
      tabIndex={props.tabIndex}
      vectorEffect="non-scaling-stroke"
      viewBox="0 0 34 23"
      xmlns="http://www.w3.org/2000/svg"
    >
      {props.title ? (
        <title id={props.ariaTags.labelledBy} lang="en">
          {props.title}
        </title>
      ) : null}
      <g fill="none" fillRule="evenodd">
        <path
          className={theme.fill}
          d="M16.866 7.178c-2.531 0-4.573 2.014-4.573 4.508s2.042 4.508 4.573 4.508c2.531 0 4.573-2.014 4.573-4.508s-2.042-4.508-4.573-4.508m0 12.021c-4.207 0-7.622-3.365-7.622-7.513 0-4.147 3.415-7.513 7.622-7.513 4.208 0 7.623 3.366 7.623 7.513 0 4.148-3.415 7.513-7.623 7.513m0-18.783C9.244.416 2.735 5.09.098 11.686c2.637 6.597 9.146 11.27 16.768 11.27 7.623 0 14.131-4.673 16.768-11.27C30.997 5.09 24.489.416 16.866.416"
        />
      </g>
    </svg>
  )
}

ViewSolid.propTypes = {
  ariaTags: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  svg: PropTypes.string.isRequired,
  theme: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  className: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
}
